
import { FaReact} from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";
import { SiTailwindcss, SiJavascript, SiHtml5,SiCss3,SiRedux } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <SiJavascript />,
    title: "Javascript",
    des: "As a JavaScript developer, I am creating dynamic, interactive web applications, ensuring seamless user experiences and high performance."
  },
  {
    id: 2,
    icon: <FaReact />,
    title: "React Js",
    des: "As a React JS developer, I am creating dynamic, responsive web interfaces, showcasing high-performance applications and seamless user experiences.",
  },
  {
    id: 3,
    icon: <SiRedux />,
    title: "Redux (RTK)",
    des: "As a Redux JS developer, I am managing complex application state, ensuring predictable and efficient data flow for seamless user experiences.",
  },
  {
    id: 4,
    icon: <SiHtml5 />,
    title: "HTML",
    des: "As an HTML developer, I structure web content for clarity and accessibility, ensuring a solid foundation for seamless user experiences",
  },
  {
    id: 5,
    icon: <SiCss3 />,
    title: "CSS",
    des: "As a CSS developer, I designing visually appealing and responsive web interfaces, enhancing user experiences through creative styling and layout techniques.",
  },
  {
    id: 6,
    icon: <SiTailwindcss />,
    title: "Tailwind CSS",
    des: "As a Tailwind CSS developer, I streamline web styling with utility-first classes, ensuring rapid and consistent UI development while maintaining flexibility and scalability in design.",
  },
];
